
module.exports = { 
      attributes: {"title":"footer","logoFooter":"/img/logo-amb-footer.svg","addressFooter":"22 avenue James Cook\\\nBP 97 - 98845 NOUMEA CEDEX","phoneFooter":"+687 23 29 10","faxFooter":"+687 28 73 88","mailFooter":"amb@amb.nc","position":"{\"type\":\"Point\",\"coordinates\":[166.4314495,-22.2676903]}"},
    
      html: "",
     }